import { render, staticRenderFns } from "./BaseLoginMFA.vue?vue&type=template&id=acb4e9a4&scoped=true&"
import script from "./BaseLoginMFA.vue?vue&type=script&lang=js&"
export * from "./BaseLoginMFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb4e9a4",
  null
  
)

export default component.exports